import React, { useState, useEffect } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { useVsiAppContext } from "../stores/VsiApp";
import styles from "../utils/themeStyles";
import { genericColors } from "../utils/chartUtils";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

require("highcharts/indicators/indicators")(Highcharts);
require("highcharts/indicators/pivot-points")(Highcharts);
require("highcharts/indicators/macd")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);


function Gauges({ series, data, includeLegend, title, height, size }) {
    const { theme, isTabletScreen } = useVsiAppContext();
    const basicTextStyle = {
        color: styles[theme].textColor,
        fontFamily: styles[theme].fontFamily,
    };

    const updateSeries = (series, data) => {
        if (series) return series;
        else if (data)
            return [
                {
                    data,
                },
            ];
        return [];
    };

    const [chartOptions, setChartOptions] = useState(
       {
           credits: {
               enabled: false,
           },
           colors: genericColors,
            chart: {
                backgroundColor: 'transparent' || styles[theme].cardBgColor,
                color: styles[theme].textColor,
                type: 'gauge',
                height: height || 400,

            },
           plotOptions: {
               gauge: {
                   innerSize: 80
               }
           },
            pane: {
                startAngle: -135,
                endAngle: 135,
                background: null,
                center: ['50%', '60%'],
                size: size || '100%'
            },
            title: {
                text: title,
                style: {
                    ...basicTextStyle,
                    fontSize: "18px"
                }
            },
            tooltip: {
                pointFormat: '{series.name} <b>{point.percentage:.1f}</b> <br/> <b>{point.y}%</b>',
                backgroundColor: styles[theme].altBgColor,
                style: basicTextStyle,
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            yAxis: {
                min: 0,
                max: 100,
                tickPixelInterval: 72,
                tickColor: styles[theme].textColor,
                tickLength: 20,
                tickWidth: 2,
                minorTickColor: "black",
                labels: {
                    distance: -35,
                    style: {
                        fontSize: '14px',
                        color: styles[theme].textColor
                    }
                },
                plotBands: [{
                    from: 0,
                    to: 15,
                    color: 'blue',
                    thickness: '10%'
                }, {
                    from: 15,
                    to: 65,
                    color: 'green',
                    thickness: '10%'
                }, {
                    from: 65,
                    to: 80,
                    color: 'yellow',
                    thickness: '10%'
                }, {
                    from: 80,
                    to: 100,
                    color: 'red',
                    thickness: '10%'
                }],
            },
            mapNavigation: {
              enabled: false
            },
            legend: {
                itemStyle: basicTextStyle,
                align: "center",
                enabled: !!includeLegend
            },
            series: updateSeries(series, data),
        }
    );

    useEffect(() => {
        setChartOptions({
            ...chartOptions,
            chart: {
                ...chartOptions.chart,
                height: height || 400,
            },
            title: {
                ...chartOptions.title,
                text: title,
                style: {
                    ...chartOptions.title.style,
                    ...basicTextStyle,
                }
            },
            legend: {
                ...chartOptions.legend,
                itemStyle: basicTextStyle,
                align: "center",
                enabled: !!includeLegend
            },
            series: updateSeries(series, data),
        })
    }, [height, includeLegend, isTabletScreen, data, series])

    return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
}

Gauges.displayName = "Gauges"

export default withErrorBoundary(Gauges, GeneralErrorBoundary);
